import { text } from "@quickpoint.me/shared";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { enterReadMode, exitReadMode } from "../../lib/messageBus";
import { HostId, ReadMode } from "../../state/atoms";
import { IsInPortrait } from "../../state/selectors";
import { MousedOverTextHelper } from "../../state/uiAtoms";
import { TopBarControl } from "../StyledControl";

function ReadControl() {
  const [inReadMode, setReadMode] = useRecoilState(ReadMode);
  const setTextHelper = useSetRecoilState(MousedOverTextHelper);
  const isInPortrait = useRecoilValue(IsInPortrait);
  const hostId = useRecoilValue(HostId);

  const handleClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    const toggleRead = !inReadMode;
    e.stopPropagation();
    setReadMode(toggleRead);
    if (toggleRead) {
      enterReadMode(hostId);
    } else {
      exitReadMode(hostId);
    }
  };

  const mouseOver = () => {
    setTextHelper(text.controls.read);
  };

  const mouseLeave = () => {
    setTextHelper(undefined);
  };

  return (
    <TopBarControl
      $isInPortrait={isInPortrait}
      onClick={handleClick}
      onMouseOver={mouseOver}
      onMouseLeave={mouseLeave}
    >
      {text.controls.read}
    </TopBarControl>
  );
}

export default ReadControl;
